import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';
import * as icv from 'src/icv';

import { a } from './_csAbt';
import * as l from './_csLcl';

import * as BoxC from './_ccbBoxC';
import * as GridC from './_cccGridC';
import * as SrlC from './_ccbSrlC';
import * as PnnC from './_ccmPnnC';

const TblC = React.memo((pz: ht.tblCz) => {

  const _sPnnz = l.useDz();

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.tblAbtz[_abtType] ? ica.tblAbtz[_abtType]() : {};

  const _rows = pz.bdyCz.lineCs;

  const _ls = [

    cr.c(GridC.N, {
      key: -10,
      ... _abtz.hdrCz,
      ... pz.hdrCz,
    }),

    cr.c(GridC.N, {
      key: -20,
      ... _abtz.bdyCz,
      ... pz.bdyCz,
      lineCs: _rows.filter( ( _dz: ht.dz, _nIdx: ht.n ) => _nIdx >= _sPnnz.crt.nCrtIdxStt && _nIdx <= _sPnnz.crt.nCrtIdxEnd),
      msgCz: {
        ... pz.bdyCz.msgCz,
        textz: {
          pfx: '該当なし',
          stlz: a('mb/1'),
        }
      }
    }),

    cr.c(PnnC.N, {
      key: -30,
      ... _abtz.pnnCz,
      ... pz.pnnCz,
      cz: {
        nTtlCnt: _rows?.length,
        nCntPerPage: icv.nCntPerPageMax ?? 100,
        onChg: ( _dz: ht.dz ) => {
          _sPnnz.set(_dz);
        },
      },
    }),

  ];

  return (
    pz.srlCz ?
      cr.c(SrlC.V, {
        key: 'TblC.root',
/*
        srlPtyz: {
          stickyHeaderIndices: [0],
        },
*/
        ... _abtz.srlCz,
        ... pz.srlCz,
        oClds: _ls,
      })
    :
      cr.c(BoxC.N, {
        key: 'TblC.root',
        ... _abtz.boxCz,
        ... pz.boxCz,
        oClds: _ls,
      })
  )
});
export const N = TblC;
